import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  children: ReactNode;
  /** CSS selector or live element. Defaults to `document.body`. */
  target?: HTMLElement | string | null;
}

/** Render `children` into a different DOM tree (default body). SSR-safe. */
export function Portal({ children, target }: PortalProps): ReactNode {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted || typeof document === 'undefined') return null;

  const el = typeof target === 'string' ? document.querySelector(target) as HTMLElement | null : target ?? document.body;
  if (!el) return null;
  return createPortal(children, el);
}
